import Vue from 'vue';
import Vuex from 'vuex';
import { MonCompteShopAuthProvider, StoreFactory as ShopAuthStoreFactory } from '@holdingblachere/vuex-shop-auth';
import { MonCompteOidcProvider, StoreFactory as UserAuthStoreFactory, AzureActiveDirectoryOidcProvider } from '@holdingblachere/vuex-auth';
import permissions from './permissions';

Vue.use(Vuex);

const monCompteShopAuthProvider = new MonCompteShopAuthProvider('mon-compte-shop-auth', {
  baseUrl: process.env.VUE_APP_MON_COMPTE_BACKEND_URL,
  storage: localStorage,
});

const monCompteOidcProvider = new MonCompteOidcProvider('mon-compte-oidc', {
  authority: `${process.env.VUE_APP_MON_COMPTE_BACKEND_URL}/oidc`,
  clientId: `${process.env.VUE_APP_MON_COMPTE_OIDC_CLIENT_ID}`,
  redirectUri: `${process.env.VUE_APP_FRONTEND_URL}/oidc/callback`,
  responseType: 'code',
  scope: 'openid profile',
});

const azureADOidcProvider = new AzureActiveDirectoryOidcProvider('azure-ad-oidc', {
  authority: process.env.VUE_APP_AZURE_AD_AUTHORITY,
  clientId: process.env.VUE_APP_AZURE_AD_CLIENT_ID,
  redirectUri: `${process.env.VUE_APP_FRONTEND_URL}/oidc/callback-ad`,
  responseType: 'code',
  scope: 'openid profile',
});

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    shopAuth: ShopAuthStoreFactory.CreateStoreModule([
      monCompteShopAuthProvider,
    ]),
    auth: UserAuthStoreFactory.CreateStoreModule([
      monCompteOidcProvider,
      azureADOidcProvider,
    ]),
    permissions,
  },
});
